import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { EXPORT_DOCUMENT_ALLOWED_STATE_RIGHTS_LIST } from '../../../mutations';
import { AUTOMATIC_STATE_TRANSITIONS_FILTERS_QUERY } from '../../../queries';
import { buildExportDownloadUrl } from 'features/downloadList/api';
import { CloudDownload } from '@mui/icons-material';
import { fileType } from 'constants/fileTypes';
import { useSimpleError } from 'hooks/apolloWrappers';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { convertBase64ToFile } from 'utils/base64FileConversion';
import saveAs from 'file-saver';
import { IconButton } from '@totalsoft/rocket-ui';
import { getOidcConfigName } from 'utils/functions';
import { useOidcAccessToken } from '@axa-fr/react-oidc';

const ExportAction = () => {
  const [t] = useTranslation();
  const showError = useSimpleError();
  const [filters, setFilters] = useState({});
  const { accessToken } = useOidcAccessToken(getOidcConfigName());

  const [exportAnchorEl, setShowHandleClose] = useState(null);
  const isExportOpen = Boolean(exportAnchorEl);

  const [exportAutomaticStateTransitions] = useMutation(EXPORT_DOCUMENT_ALLOWED_STATE_RIGHTS_LIST, {
    onCompleted: async ({ exportAutomaticStateTransitions }) => {
      let downloadLink = null;
      try {
        if (exportAutomaticStateTransitions.fileBytes) {
          saveAs(convertBase64ToFile(exportAutomaticStateTransitions.fileBytes), exportAutomaticStateTransitions.fileName);
          return;
        }
        downloadLink = await buildExportDownloadUrl(
          exportAutomaticStateTransitions.filePath,
          exportAutomaticStateTransitions.fileName,
          accessToken
        );
      } catch (error) {
        showError(error);
      }
      if (downloadLink) {
        window.location.href = downloadLink;
      }
    }
  });

  useQuery(AUTOMATIC_STATE_TRANSITIONS_FILTERS_QUERY, {
    onCompleted: data => {
      if (data)
        setFilters({
          documentCode: data.automaticStateTransitionListFilters.documentCode.value?.trim(),
          documentName: data.automaticStateTransitionListFilters.documentName.value?.trim(),
          fromStateCode: data.automaticStateTransitionListFilters.fromStateCode.value?.trim(),
          fromStateName: data.automaticStateTransitionListFilters.fromStateName.value?.trim(),
          inactive: data.automaticStateTransitionListFilters.inactive.value,
          fullTextFilter: data.automaticStateTransitionListFilters.fullTextFilter.value?.trim()
        });
    }
  });

  const onExport = filters => {
    exportAutomaticStateTransitions({ variables: { input: filters } });
  };

  const handleExportClose = () => {
    setShowHandleClose(null);
  };

  const handleExportClick = event => {
    setShowHandleClose(event.currentTarget);
  };

  const handleExport = (fileType, filters) => () => {
    onExport({ ...filters, fileType });
    setShowHandleClose(null);
  };

  return (
    <>
      <Tooltip placement='top' title={t('Tooltips.DownloadAutomaticStateTransitionList')}>
        <div>
          <IconButton color='primary' onClick={handleExportClick}>
            <CloudDownload />
          </IconButton>
          <Menu id='render-export-menu' anchorEl={exportAnchorEl} open={isExportOpen} onClose={handleExportClose}>
            <MenuItem onClick={handleExport(fileType.excel, filters)}>{t('Export.Excel')}</MenuItem>
            <MenuItem onClick={handleExport(fileType.csv, filters)}>{t('Export.CSV')}</MenuItem>
          </Menu>
        </div>
      </Tooltip>
    </>
  );
};

export default ExportAction;
